var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 125 36.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1e7faf;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-width: 0px;\n      }\n\n      .cls-10 {\n        stroke-width: .01px;\n      }\n\n      .cls-10, .cls-11, .cls-6, .cls-12, .cls-13 {\n        fill: #fff;\n      }\n\n      .cls-10, .cls-11, .cls-12, .cls-13 {\n        stroke: #222221;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-11 {\n        stroke-width: .02px;\n      }\n\n      .cls-2 {\n        fill: url(#D\xE9grad\xE9_sans_nom_10-4);\n      }\n\n      .cls-3 {\n        fill: url(#D\xE9grad\xE9_sans_nom_10-2);\n      }\n\n      .cls-4 {\n        fill: #323c55;\n      }\n\n      .cls-5 {\n        fill: #6fadcc;\n      }\n\n      .cls-12 {\n        stroke-width: .01px;\n      }\n\n      .cls-7 {\n        fill: url(#D\xE9grad\xE9_sans_nom_10);\n      }\n\n      .cls-8 {\n        fill: url(#D\xE9grad\xE9_sans_nom_10-3);\n      }\n\n      .cls-9 {\n        fill: #ebb544;\n      }\n\n      .cls-13 {\n        stroke-width: .02px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10",
    "data-name": "D\\xE9grad\\xE9 sans nom 10",
    x1: 97.91,
    y1: 16.48,
    x2: 98.07,
    y2: 0.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#323c55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#0d69aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10-2",
    "data-name": "D\\xE9grad\\xE9 sans nom 10",
    x1: 84.75,
    y1: 13.18,
    x2: 84.64,
    y2: 6.64,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10-3",
    "data-name": "D\\xE9grad\\xE9 sans nom 10",
    x1: 90.9,
    y1: 23.93,
    x2: 88.32,
    y2: 23.48,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10-4",
    "data-name": "D\\xE9grad\\xE9 sans nom 10",
    x1: 104.21,
    y1: 24.03,
    x2: 108.15,
    y2: 23.58,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M11.85,8.67c1.13,0,2.01.12,2.62.36.61.24,1.14.49,1.59.76.23.13.42.24.56.3.14.07.28.1.42.1.19,0,.33-.11.42-.32.09-.21.16-.53.22-.95h.66c-.02.37-.04.8-.07,1.31-.03.51-.05,1.18-.06,2,0,.83-.01,1.91-.01,3.26h-.66c-.08-1-.31-1.97-.69-2.91-.38-.94-.93-1.72-1.63-2.32-.7-.61-1.56-.91-2.58-.91-.92,0-1.68.26-2.28.78-.6.52-.89,1.24-.89,2.16,0,.77.19,1.43.58,1.97.38.55.95,1.08,1.69,1.6.74.52,1.64,1.14,2.7,1.87.92.6,1.75,1.19,2.48,1.79.73.6,1.32,1.27,1.76,2.02.44.75.66,1.64.66,2.68,0,1.27-.33,2.32-.99,3.14-.66.83-1.53,1.45-2.61,1.86-1.08.41-2.26.62-3.55.62-1.19,0-2.14-.12-2.85-.35-.71-.23-1.31-.47-1.79-.72-.42-.27-.75-.4-.98-.4-.19,0-.33.11-.42.32-.09.21-.16.53-.22.95h-.66c.04-.46.06-1,.07-1.61,0-.61.02-1.42.03-2.41,0-.99.01-2.24.01-3.76h.66c.08,1.27.29,2.46.65,3.56.36,1.11.9,1.99,1.64,2.67.74.67,1.72,1.01,2.95,1.01.67,0,1.27-.12,1.8-.36.53-.24.96-.6,1.28-1.08.33-.48.49-1.08.49-1.79,0-.81-.19-1.51-.56-2.1-.37-.6-.88-1.15-1.53-1.67-.64-.52-1.39-1.05-2.23-1.59-.9-.6-1.75-1.19-2.54-1.79-.79-.6-1.42-1.28-1.89-2.05-.47-.77-.71-1.68-.71-2.74,0-1.21.3-2.21.91-2.98.61-.78,1.4-1.35,2.39-1.73.99-.37,2.04-.56,3.16-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.88,14.15c.75,0,1.44.08,2.06.25.62.16,1.14.37,1.54.62.5.31.89.69,1.17,1.14.28.45.42.98.42,1.57,0,.67-.21,1.23-.63,1.66-.42.43-.97.65-1.64.65s-1.21-.19-1.61-.58c-.4-.38-.61-.9-.61-1.56,0-.61.19-1.13.58-1.54.38-.41.83-.69,1.33-.82-.15-.19-.38-.36-.69-.49-.31-.13-.65-.2-1.04-.2-.6,0-1.12.17-1.57.52-.45.35-.83.83-1.14,1.44-.31.62-.54,1.34-.71,2.16-.16.83-.25,1.73-.25,2.71,0,1.48.19,2.64.56,3.49.37.85.85,1.44,1.44,1.79.59.35,1.2.52,1.83.52.36,0,.76-.06,1.2-.17.43-.12.87-.35,1.33-.69.45-.35.87-.84,1.25-1.47l.49.17c-.21.71-.56,1.42-1.04,2.13-.48.71-1.11,1.29-1.87,1.74-.77.45-1.71.68-2.82.68-1.25,0-2.38-.27-3.39-.82-1.01-.55-1.82-1.39-2.42-2.54-.61-1.14-.91-2.62-.91-4.42s.31-3.19.94-4.37c.62-1.18,1.47-2.07,2.55-2.67,1.08-.6,2.3-.89,3.66-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.68,14.15c.61,0,1.11.13,1.5.39.38.26.67.59.85.99.18.4.27.83.27,1.27,0,.71-.21,1.29-.62,1.74-.41.45-.96.68-1.63.68s-1.2-.17-1.57-.5c-.37-.34-.56-.78-.56-1.34s.12-.98.36-1.34c.24-.36.54-.66.91-.91-.27-.08-.54-.07-.81.03-.37.06-.71.21-1.04.45-.33.24-.61.54-.84.89-.23.36-.41.74-.55,1.15-.13.41-.2.81-.2,1.2v7.64c0,.92.23,1.55.68,1.87.45.33,1.13.49,2.03.49v.61c-.44-.02-1.09-.04-1.93-.07-.85-.03-1.73-.04-2.65-.04-.77,0-1.55.01-2.33.04-.79.03-1.38.05-1.79.07v-.61c.67,0,1.15-.14,1.43-.43.28-.29.42-.84.42-1.64v-9.08c0-.86-.13-1.5-.39-1.92-.26-.41-.75-.62-1.46-.62v-.61c.61.06,1.21.09,1.79.09.81,0,1.56-.03,2.26-.1.7-.07,1.35-.17,1.95-.3v2.68c.23-.52.54-.99.92-1.41.38-.42.83-.75,1.33-.99.5-.24,1.06-.36,1.67-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56.07,14.24v12.54c0,.81.14,1.35.42,1.64.28.29.75.43,1.43.43v.61c-.37-.02-.91-.04-1.63-.07s-1.46-.04-2.21-.04-1.51.01-2.28.04c-.77.03-1.35.05-1.73.07v-.61c.67,0,1.15-.14,1.43-.43.28-.29.42-.84.42-1.64v-9.08c0-.86-.13-1.5-.39-1.92-.26-.41-.75-.62-1.46-.62v-.61c.61.06,1.21.09,1.79.09.81,0,1.56-.03,2.26-.1.7-.07,1.35-.17,1.95-.3ZM53.82,7.12c.81,0,1.45.2,1.92.59.47.39.71.94.71,1.63s-.24,1.24-.71,1.63c-.47.39-1.11.59-1.92.59s-1.45-.2-1.92-.59c-.47-.39-.71-.94-.71-1.63s.24-1.23.71-1.63c.47-.39,1.11-.59,1.92-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64.78,14.24v17.58c0,.9.23,1.5.69,1.8.46.3,1.1.45,1.9.45v.61c-.5-.02-1.19-.04-2.06-.07-.87-.03-1.8-.04-2.78-.04-.71,0-1.41.01-2.09.04-.68.03-1.2.05-1.54.07v-.61c.63,0,1.08-.13,1.34-.4.26-.27.39-.79.39-1.56v-14.41c0-.86-.13-1.5-.4-1.92-.27-.41-.75-.62-1.44-.62v-.61c.61.06,1.21.09,1.79.09.79,0,1.54-.03,2.25-.1.71-.07,1.36-.17,1.96-.3ZM69.25,14.15c.98,0,1.85.26,2.62.79.77.53,1.38,1.33,1.84,2.39.46,1.07.69,2.4.69,3.99,0,1.4-.16,2.63-.48,3.69-.32,1.06-.77,1.95-1.35,2.67-.59.72-1.29,1.26-2.1,1.63-.82.36-1.73.55-2.75.55-.75,0-1.43-.13-2.05-.39-.62-.26-1.09-.63-1.41-1.11l.29-.37c.19.35.47.62.82.81.36.19.76.29,1.23.29.86,0,1.55-.29,2.05-.88.5-.59.86-1.41,1.08-2.48.22-1.07.33-2.34.33-3.82,0-1.65-.11-2.95-.32-3.89-.21-.94-.5-1.61-.86-2.02-.37-.4-.81-.61-1.33-.61-.69,0-1.32.27-1.89.81-.57.54-.89,1.31-.97,2.31l-.14-1.01c.35-1.1.94-1.93,1.77-2.49.84-.57,1.81-.85,2.93-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.83,9.83v4.73h3.4v.58h-3.4v11.65c0,.58.11.99.32,1.23.21.24.53.36.95.36.35,0,.69-.13,1.04-.39.35-.26.65-.71.92-1.34l.49.26c-.31.86-.77,1.58-1.4,2.13-.62.56-1.48.84-2.55.84-.63,0-1.19-.08-1.67-.25-.48-.16-.88-.41-1.21-.74-.42-.42-.7-.95-.84-1.57-.13-.62-.2-1.44-.2-2.44v-9.74h-2.42v-.58h2.42v-3.81c.81,0,1.55-.07,2.23-.22.68-.14,1.32-.38,1.92-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.73,14.15c.61,0,1.11.13,1.5.39.38.26.67.59.85.99.18.4.27.83.27,1.27,0,.71-.21,1.29-.62,1.74-.41.45-.96.68-1.63.68s-1.2-.17-1.57-.5c-.37-.34-.56-.78-.56-1.34s.12-.98.36-1.34c.24-.36.54-.66.91-.91-.27-.08-.54-.07-.81.03-.37.06-.71.21-1.04.45-.33.24-.61.54-.84.89-.23.36-.41.74-.55,1.15-.13.41-.2.81-.2,1.2v7.64c0,.92.23,1.55.68,1.87.45.33,1.13.49,2.03.49v.61c-.44-.02-1.09-.04-1.93-.07-.85-.03-1.73-.04-2.65-.04-.77,0-1.55.01-2.33.04-.79.03-1.38.05-1.79.07v-.61c.67,0,1.15-.14,1.43-.43.28-.29.42-.84.42-1.64v-9.08c0-.86-.13-1.5-.39-1.92-.26-.41-.74-.62-1.46-.62v-.61c.61.06,1.21.09,1.79.09.81,0,1.56-.03,2.26-.1.7-.07,1.35-.17,1.95-.3v2.68c.23-.52.54-.99.92-1.41.38-.42.83-.75,1.33-.99.5-.24,1.06-.36,1.67-.36Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 83.47,
    y: 33.15,
    width: 25.4,
    height: 1.98,
    rx: 0.32,
    ry: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M109.55,33.19l2.88.68c.29.07.29.47,0,.54l-2.88.68c-.17.04-.34-.09-.34-.27v-1.36c0-.18.17-.31.34-.27Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M111.12,9.52l-13,7.21c-.09.05-.19.05-.28,0l-13-7.21c-.2-.11-.2-.4,0-.51l13-7.21c.09-.05.19-.05.28,0l13,7.21c.2.11.2.4,0,.51Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 84.72,
    cy: 11.1,
    rx: 0.48,
    ry: 1.61
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.52,22.87c.18,6.96-3.89,10.08-8.68,10.08s-8.65-2.65-8.65-9.61,2.28-15.59,8.65-15.59c6.72,0,8.52,8.92,8.68,15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M92.59,19.86s-3.94,4.71.11,11.48c0,0-1.51-1.18-2.18-2.24l.39,1.08s-3.68-2.32-3.7-6.75c-.02-4.43,3.17-6.67,3.17-6.67l2.21,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.04,19.86s3.94,4.71-.11,11.48c0,0,1.51-1.18,2.18-2.24l-.39,1.08s3.68-2.32,3.7-6.75-3.17-6.67-3.17-6.67l-2.21,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97.4,18.28s-.4.57-.64.7l.18-.46s-.5.94-.8.97-.5.66-1.39.88-1.85.37-2.35.35l.12.15s-.96-.09-1.1-.35l-.1.18s-2.29-1.25-2.67-2.77.18-5.1,1.69-6.49,1.76-1.68,1.76-1.68c0,0,1.83-1.8,4.2-1.96h.18s-.68-.57-1.75-.24c0,0,1.02-.86,2.39.24,0,0-.62-.92-.64-1.34,0,0,.46.73.6.79,0,0-.32-.62-.06-.9,0,0,.14.7.6,1.08,0,0,0-.57.42-.88,0,0-.18.7-.12,1.14s0,.26,0,.26c0,0,.22-1.27,1.47-1.23,0,0-.58.26-.68.73l-.06.15s.6-.62,1.24-.66c.7-.04,1.14.11,1.14.11,0,0-1.39.02-1.43.51,0,0,3.01-.29,5.94,3.43,2.93,3.71,1.93,7.27,1.93,7.27,0,0-.76,2.18-2.73,2.7,0,0,.96-.77.96-.92,0,0-1.51,1.08-3.01,1.27s-3.77-1.23-4.38-2.59l.08.53s-.46-.44-.5-1.21c0,0-.24.62-.72.99l.24-.75Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 93.49,
    cy: 16.36,
    rx: 3.65,
    ry: 4.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 94.2,
    cy: 16.23,
    rx: 2.38,
    ry: 2.63
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 94.19,
    cy: 16.25,
    rx: 1.59,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 95.27,
    cy: 15.36,
    rx: 0.26,
    ry: 0.27
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 94.2,
    cy: 14.92,
    rx: 0.43,
    ry: 0.45
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 102.08,
    cy: 16.07,
    rx: 3.78,
    ry: 4.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 102.08,
    cy: 16.38,
    rx: 2.47,
    ry: 2.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 102.19,
    cy: 16.42,
    rx: 1.65,
    ry: 1.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 101.63,
    cy: 15.37,
    rx: 0.28,
    ry: 0.29,
    transform: "translate(52.5 105.65) rotate(-70.05)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 102.59,
    cy: 14.88,
    rx: 0.46,
    ry: 0.48,
    transform: "translate(53.59 106.23) rotate(-70.05)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M97.42,18.24l-.89,1.02c-.06.06-.07.15-.03.23l.86,1.69c.13.26.5.27.64.02l1.01-1.75c.06-.1.04-.21-.05-.29l-1.02-.94c-.15-.14-.39-.13-.52.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.76,11.51c-1.02-1.19-1.79-3.09-1.79-3.09.62.48,1.61.69,3.6.97.47.07,1,.14,1.59.22l-3.4,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.19,11.22c1.02-1.19,1.79-3.09,1.79-3.09-.62.48-1.61.69-3.6.97-.47.07-1,.14-1.59.22l3.4,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.3,16.15s-.27-3.51,1.66-4.71,3.4-.18,3.4-.18c0,0,.89.65,2.21-.05,0,0-.6,1.65-2.36,1.16-1.65-.45-2.72.1-2.72.1,0,0-1.34.73-2.18,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.14,16.52s.35-3.53-1.58-4.73-3.4-.18-3.4-.18c0,0-.89.65-2.21-.05,0,0,.6,1.65,2.36,1.16,1.65-.45,2.72.1,2.72.1,0,0,1.26.75,2.1,3.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.56,33.5c0,.47-.25.73-.64,1.02-.35.26-.81.58-1.32.58-.43,0-.83-.28-1.16-.48-.49-.29-.8-.59-.8-1.12,0-.49.27-1.09.69-1.39.34-.24.78-.21,1.27-.21.54,0,1.03-.15,1.39.14s.57,1.02.57,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.37,33.38c0,.47-.25.73-.64,1.02-.35.26-.81.58-1.32.58-.43,0-.83-.28-1.16-.48-.49-.29-.8-.59-.8-1.12,0-.49.27-1.09.69-1.39.34-.24.78-.21,1.27-.21.54,0,1.03-.15,1.39.14s.57,1.02.57,1.46Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.0f233703072e702c81c14f06bfb1fe67.svg";
export { ForwardRef as ReactComponent };